import { defineStyleConfig, extendTheme } from "@chakra-ui/react";
import "@fontsource/red-hat-text"; // Defaults to weight 400
const theme = extendTheme({
  styles: {
    global: {
      body: {
        color: "#FFFFFF", // Remplacez par la couleur de texte par défaut souhaitée
      },
    },
  },
  fonts: {
    body: `'Red Hat Text', sans-serif`,
  },

  components: {
    Text: defineStyleConfig({
      variants: {
        default: {
          fontFamily: `'Red Hat Text', sans-serif`,
        },
      },
      // Default variant
    }),
  },
});
export default theme;
